import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    placeItems: 'center',
    paddingTop: '2rem',
    fontSize: theme.size.base
  }
}))

export default useStyles
